import { render, staticRenderFns } from "./CertificateAddPage.vue?vue&type=template&id=6b9e7038&scoped=true&"
import script from "./CertificateAddPage.vue?vue&type=script&lang=js&"
export * from "./CertificateAddPage.vue?vue&type=script&lang=js&"
import style0 from "./CertificateAddPage.vue?vue&type=style&index=0&id=6b9e7038&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9e7038",
  null
  
)

export default component.exports